import React from "react";
import { Container } from "react-bootstrap";
import Particle from "../Particle";
import pokemonCard from "../../Assets/PokemonCard.mov";

function PokemonCardVideo() {
  return (
    <Container fluid className="project-section" style={{ minHeight: "100vh", display: "flex", alignItems: "center", justifyContent: "center" }}>
      <Particle />
      <Container style={{ maxWidth: "1920px" }}>
        <h1 className="project-heading" style={{ textAlign: "center" }}>
          Pokemon <strong className="purple">Card</strong>
        </h1>
        <video
          src={pokemonCard}
          controls
          autoPlay
          loop
          muted
          playsInline
          style={{ width: "100%", aspectRatio: "16/9", borderRadius: "10px", opacity: "0.9" }}
        />
      </Container>
    </Container>
  );
}

export default PokemonCardVideo;
